import styled from 'styled-components';
import { media } from '../../theme';

const PageTitle = ({ title }: any) => {
  return <Title>{title}</Title>;
};
export default PageTitle;

/*
 * line-height (24px) font-size'tan (32px) küçük: tek satırda sorun değil, ama
 * dar ekranda başlık iki satıra sarınca satırlar üst üste biniyordu.
 * Sarma ihtimali olan yerde satır yüksekliği fontu geçmeli.
 */
const Title = styled.div`
  font-size: 32px;
  font-weight: 600;
  line-height: 24px;

  ${media.mobile} {
    font-size: 22px;
    line-height: 28px;
  }
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
